import { Opacity } from '@usacsmideo/types';

export const OpacityController = (props: Opacity) => {
  const MIN_OPACITY = 0.35;
  const MAX_OPACITY = 0.90;

  return (
    <div className="my-2 grid w-full grid-cols-[auto_1fr_auto] items-center gap-4">
      <button
        type="button"
        id="more-video"
        onClick={() => {
          props.setOpacity(Math.max(MIN_OPACITY, props.opacity - 0.05));
        }}
        className="text-left"
        aria-label="Decrease text opacity to show more video"
      >
        <p>Video</p>
      </button>
      <input
        id="transparency-slider"
        className="slider"
        type="range"
        min="35"
        max="90"
        value={Math.round(props.opacity * 100)}
        onChange={(e) => props.setOpacity(parseInt(e.target.value) / 100)}
        disabled={props.scrolling}
        aria-label="Adjust text opacity"
        aria-valuetext={`Opacity: ${Math.round(props.opacity * 100)}%`}
      />
      <button
        type="button"
        id="more-text"
        onClick={() => {
          props.setOpacity(Math.min(MAX_OPACITY, props.opacity + 0.05));
        }}
        className="text-right"
        aria-label="Increase text opacity to show more text"
      >
        <p>Text</p>
      </button>
    </div>
  );
};
